import React, { useState, useEffect } from "react";
import SearchList from "./searchList";
import Footer from "../../home/footer";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import Navbar from "../../landingpage/sections/Navbar";

const SearchCeleb = (props) => {
  const [searchQuery, setSearchQuery] = useState("");
  const location = useLocation();

  // Get search query from URL parameters
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const query = queryParams.get('q') || '';
    setSearchQuery(query);
  }, [location]);

  const handleSearch = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      <Navbar {...props} />
      {/* Breadcrumb */}
      <div className="breadcrumb-bar overflow-visible" style={{
        backgroundColor: 'var(--breadcrumb-bg)',
        transition: 'background-color 0.3s ease'
      }}>
        <div className="container">
          <div className="row align-items-center inner-banner">
            <div className="col-md-12 col-12 text-center">
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="isax isax-home-15" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Celeb</li>
                  <li className="breadcrumb-item active">Celebs Grid</li>
                </ol>
                <h2 className="breadcrumb-title">Search Celebrities</h2>
              </nav>
            </div>
          </div>
          <div className="bg-primary-gradient rounded-pill doctors-search-box">
            <div className="search-box-one rounded-pill">
              <form onSubmit={handleSearch}>
                <div className="search-input search-line" style={{ width: '85%' }}>
                  <i className="isax isax-people bficon" />
                  <div className=" mb-0">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search for celebrities, Musicians, Actors, Sportsmen, content creators etc"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>
                <div className="form-search-btn">
                  <button
                    className="btn btn-primary d-inline-flex align-items-center rounded-pill"
                    type="submit"
                  >
                    <i className="isax isax-search-normal-15 me-2" />
                    Search
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="breadcrumb-bg">
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-bg-01.png"
            alt="img"
            className="breadcrumb-bg-01"
          />
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-bg-02.png"
            alt="img"
            className="breadcrumb-bg-02"
          />
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-icon.png"
            alt="img"
            className="breadcrumb-bg-03"
          />
          <ImageWithBasePath
            src="assets/img/bg/breadcrumb-icon.png"
            alt="img"
            className="breadcrumb-bg-04"
          />
        </div>
      </div>
      {/* /Breadcrumb */}
      <div className="content">
        <div className="container">
          <div className="row">
            <SearchList searchQuery={searchQuery} />
          </div>
        </div>
      </div>
      <Footer {...props} />
    </div>
  );
};

export default SearchCeleb;